<template>
    <div class="hl-tags">
        <div class="tags">
            <tag
                    v-for="(tag, key) in getTags"
                    :key="key"
                    btn
                    :label="tag.name"
                    @click="openModel(tag)"
            ></tag>
            <div
                    class="tag tag_btn hl-tags__plus"
                    :style="{
                        'background-color': colorPrimary,
                        'border-color': colorPrimary
                    }"
                    @click="createModel"
            >
                <v-icon size="18" dark>mdi-plus</v-icon>
            </div>
        </div>
        <v-dialog
                v-model="dialog"
                width="500"
        >
            <v-card>
                <v-card-text class="pt-5">
                    <c-form
                            ref="form"
                            @submitted="dialog = false"
                    ></c-form>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import Tag from "../../../ui/Tag";
    import CForm from "./Form";

    export default {
        components: {Tag, CForm},
        data() {
            return {
                dialog: false
            }
        },
        computed: {
            colorPrimary() {
                return this.$vuetify.theme.themes.light.primary;
            },
            getTags() {
                return this.$store.state.user.profile.tag;
            }
        },
        methods: {
            createModel() {
                this.dialog = true;
                this.$nextTick(() => {
                    this.$refs.form.createModel();
                });
            },
            openModel(model) {
                this.dialog = true;
                this.$nextTick(() => {
                    this.$refs.form.openModel(model);
                });
            }
        }
    }
</script>

<style lang="scss">
    .hl-tags {
        .tags {
            display: flex;
            flex-wrap: wrap;

            .tag {
                margin: 4px;
                min-height: 26px;
            }

          .tag_btn {
            padding-left: 10px !important;
            padding-right: 10px !important;

            &.hl-tags__plus {
              min-width: 26px;
              padding: 0 !important;
            }
          }
          .tag__content {
            font-size: 13px;
          }
        }
    }
</style>